import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, formatCurrency, formatDate } from "../lib/api";
import PageHeader from "../components/PageHeader";
import StatusBadge from "../components/StatusBadge";
import { Search } from "lucide-react";

const Drivers = () => {
    const [data, setData] = useState({ total: 0, items: [] });
    const [q, setQ] = useState("");
    const [kyc, setKyc] = useState("");
    const [loading, setLoading] = useState(true);

    const fetchAll = () => {
        setLoading(true);
        const params = new URLSearchParams();
        if (q) params.set("q", q);
        if (kyc) params.set("kyc_status", kyc);
        params.set("limit", 100);
        api.get(`/drivers?${params.toString()}`)
            .then((r) => setData(r.data))
            .finally(() => setLoading(false));
    };
    useEffect(fetchAll, [kyc]);

    return (
        <div className="space-y-6">
            <PageHeader title="Drivers" subtitle={`${data.total} drivers`} />

            <div className="bg-white border border-slate-200 rounded-2xl p-4 flex flex-wrap gap-3 items-center">
                <div className="relative flex-1 min-w-[200px]">
                    <Search className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
                    <input
                        value={q}
                        onChange={(e) => setQ(e.target.value)}
                        onKeyDown={(e) => e.key === "Enter" && fetchAll()}
                        placeholder="Search by name, phone, vehicle no."
                        className="w-full pl-9 pr-3 py-2 text-sm bg-slate-50 border border-slate-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-mint-500/30"
                        data-testid="drivers-search-input"
                    />
                </div>
                <select value={kyc} onChange={(e) => setKyc(e.target.value)} className="px-3 py-2 text-sm bg-slate-50 border border-slate-200 rounded-lg" data-testid="drivers-kyc-filter">
                    <option value="">All KYC</option>
                    <option value="pending">Pending</option>
                    <option value="approved">Approved</option>
                    <option value="rejected">Rejected</option>
                </select>
            </div>

            <div className="bg-white border border-slate-200 rounded-2xl overflow-hidden">
                <div className="overflow-x-auto">
                    <table className="w-full text-sm">
                        <thead className="bg-slate-50 border-b border-slate-200">
                            <tr className="text-left text-xs font-semibold text-slate-500 uppercase tracking-wider">
                                <th className="px-4 py-3">Driver</th>
                                <th className="px-4 py-3">Vehicle</th>
                                <th className="px-4 py-3">KYC</th>
                                <th className="px-4 py-3">Online</th>
                                <th className="px-4 py-3 text-right">Rides</th>
                                <th className="px-4 py-3 text-right">Earnings</th>
                                <th className="px-4 py-3 text-right">Rating</th>
                                <th className="px-4 py-3">Joined</th>
                            </tr>
                        </thead>
                        <tbody className="divide-y divide-slate-100">
                            {loading ? (
                                <tr><td colSpan={8} className="px-4 py-10 text-center text-slate-400">Loading…</td></tr>
                            ) : data.items.map((d) => (
                                <tr key={d.id} className="hover:bg-slate-50" data-testid={`driver-row-${d.id}`}>
                                    <td className="px-4 py-3">
                                        <Link to={`/drivers/${d.id}`} className="font-semibold text-navy-900 hover:text-mint-600">{d.name}</Link>
                                        <div className="text-xs text-slate-500">{d.phone}</div>
                                    </td>
                                    <td className="px-4 py-3">
                                        <div className="font-medium text-navy-900">{d.vehicle_type}</div>
                                        <div className="text-xs text-slate-500 font-mono">{d.vehicle_number}</div>
                                    </td>
                                    <td className="px-4 py-3"><StatusBadge status={d.kyc_status} /></td>
                                    <td className="px-4 py-3">
                                        {d.online ? (
                                            <span className="inline-flex items-center gap-1.5 text-xs font-semibold text-mint-700">
                                                <span className="w-1.5 h-1.5 rounded-full bg-mint-500" /> Online
                                            </span>
                                        ) : (
                                            <span className="text-xs text-slate-400">Offline</span>
                                        )}
                                    </td>
                                    <td className="px-4 py-3 text-right tabular-nums">{d.total_rides || 0}</td>
                                    <td className="px-4 py-3 text-right font-semibold tabular-nums">{formatCurrency(d.total_earnings || 0)}</td>
                                    <td className="px-4 py-3 text-right">{d.rating} ★</td>
                                    <td className="px-4 py-3 text-slate-500">{formatDate(d.created_at)}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default Drivers;
